import { StorageAction } from './storage.action';

export interface IStorageState {
    local: {[prop: string]: string};
    cookie: {[prop: string]: string};
    session: {[prop: string]: string};
}

export const initialState: IStorageState = {
    local: {},
    cookie: {},
    session: {},
};

/**
 * Fução de reduce para a store Storage
 *
 * @param  {IStorageState=initialState} state
 * @param  {} {type
 * @param  {} payload}
 */
export function StorageReducer(state: IStorageState = initialState, { type, payload }) {

    switch (type) {

        case StorageAction.storeItem: {

            const newState = { ...state };
            newState[payload.storageType][payload.key.trim()] = payload.data;

            return newState;
        }

        case StorageAction.unstoreItem: {

            const newState = { ...state };
            delete newState[payload.storageType][payload.key.trim()];

            return newState;
        }

        default:
            return { ...state };
    }
}
